import { HTTP_STATUSES } from "@miplatform/constants";
import { useCategories } from "@mibuildweb/hooks";

export const useAddCategoriesViewModel = ({ reset, goBack }) => {
  const { isLoading, getCategoryDetails, createCategory, updateCategory } =
    useCategories();

  const handleCreateCategory = async (data) => {
    const response = await createCategory(data);
    if (response.status === HTTP_STATUSES.OK) {
      goBack();
    }
  };

  const handleUpdateCategory = async (data) => {
    const modifiedData = {
      ...data,
      attributes: data.attributes.map((attr) => ({
        ...attr,
        attributeId: attr.id,
      })),
    };
    const response = await updateCategory(modifiedData);
    if (response.status === HTTP_STATUSES.OK) {
      goBack();
    }
  };

  const fetchCategoryDetails = async (id) => {
    const response = await getCategoryDetails(id);
    if (response.status === HTTP_STATUSES.OK) {
      reset(response.data);
    }
  };

  return {
    isLoading,
    fetchCategoryDetails,
    handleCreateCategory,
    handleUpdateCategory,
  };
};
